<template>
    <div class="topcode-wechat-part-item">
        <Cell center style="height: 110px;margin-bottom: 5px;">
            <div class="body">
                <img :src="downloadImg + part.productPartImage"
                     style="height: 65px;width: 65px;background:#aaa;"/>
                <div class="name">
                    <div class="title-small">{{part.productPartName}}</div>
                    <div>{{part.productPartModel}}</div>
                </div>
            </div>
            <div slot="extra">
                <Icon name="delete" size="20" color="red"
                      style="display: flex;justify-content: flex-end;margin-bottom: 18px;" @click="deletePart"/>
                <Stepper v-model="count"/>
            </div>
        </Cell>
    </div>
</template>

<script>
    import {Cell, Dialog, Icon, Stepper} from "vant"
    import {downloadImg} from "@/config"

    export default {
        components: {Icon, Dialog, Cell, Stepper},
        props: {part: {type: Object, required: true}},
        data() {
            return {
                downloadImg,
            }
        },
        computed: {
            count: {
                get() {
                    return this.part.count;
                },
                set(count) {
                    console.error('数量变化', count)
                    this.changeCount(count)
                }
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {
            changeCount(count) {
                this.$http.tokiot.device.part.submit({...this.part, count})
                    .then(ret => {
                        if (ret) {
                            this.$toast.success('修改成功')
                        }
                    })

            },
            deletePart() {
                Dialog.confirm({
                    message: "确定删除？",
                }).then(() => {
                    this.$http.tokiot.device.part.delete({id: this.part.id})
                        .then(res => {
                            if (res) {
                                this.$toast.success("删除成功");
                                this.$emit("onRefresh")
                            }
                        })
                })
            }
        },
        watch: {},
    }
</script>
<style lang="less" scoped>
    .topcode-wechat-part-item {
        width: 100%;
        margin-bottom: 8px;
        border-radius: 8px;
        border: 1px #cccccc solid;

        .van-cell{

        }
        .body {
            display: flex;


            & > .right {
                width: 25px;
                color: #1890ff;
                font-size: 20px;
                font-weight: 500;
            }

            & > img {
                width: 60px;
                height: 60px;
                background: #cccccc;
                //  border-radius: 8px;
            }
            & > .name {
                margin-left: 20px;
                height: 100%;
                display: flex;
                /*background: #7e7e7e;*/
                flex-direction: column;
                & > div {
                    line-height: 1.5;
                }
            }
        }
        & > .row {
            display: flex;
            line-height: 1.5;
            /*align-items: center;*/
            & > label {
                width: 105px;
                flex-shrink: 0;
                &::after {
                    margin-left: 5px;
                    content: '：';
                }
            }
            & > span {
            }
        }
    }
</style>
